import React from "react";
import SearchBar from "../components/searchbar/searchBar";
import Headers from "../components/header";
import Footer from "../components/footer/footer";
import TendingStartups from "../components/trending/trendingStartups";

function Search() {
  return (
    <>
      <Headers />
      <SearchBar />
      <TendingStartups />
      <Footer />
    </>
  );
}

export default Search;
